// extracted by mini-css-extract-plugin
export var column = "footer-module--column--31d5d";
export var columnEnd = "footer-module--column-end--ac07d";
export var container = "footer-module--container--e4696";
export var copyrightLine = "footer-module--copyright-line--f13b7";
export var footer = "footer-module--footer--675c6";
export var item = "footer-module--item--cd38c";
export var logo = "footer-module--logo--62df3";
export var socialIcon = "footer-module--social-icon--a2b82";
export var socialLine = "footer-module--social-line--daea9";